<template>
  <router-link :to="localizedRoute(`/posts/${post.slug}`)" class="card-post" v-if="post">
    <div class="card-post__image">
      <SfImage :src="getPostImage(post)" />
    </div>

    <div class="card-post__text">
      <div class="badge badge-new" v-if="isPostNew(new Date(post.date))">
        Neu
      </div>

      <div class="logo">
        <SfImage src="/assets/custom/logos/logo-ruckzuck-ratgeber-badge-white.png" />
      </div>
      <!-- div class="category" v-if="getCategory(post)">
        {{ getCategory(post) }}
      </div -->
      <div class="heading">
        {{ post.title }}
      </div>
      <!-- div class="box-content" v-html="$options.filters.truncate( post.excerpt, 175, '...' )" / -->

      <div class="action">
        <div class="btn btn-circle-white-arrow-right" />
      </div>
    </div>
  </router-link>
</template>

<script>
// import PostsIndex from './Index'
import { getPostImage } from '../../helpers/index'
import { SfImage } from '@storefront-ui/vue';

export default {
  components: {
    SfImage
  },
  props: {
    post: Object
  },
  filters: {
    truncate: function (text, length, suffix) {
      return typeof text !== 'undefined' && text.length > 0 ? text.substring(0, length) + suffix : ''
    }
  },
  methods: {
    getCategory (post) {
      if (typeof post.categories.edges[0] !== 'undefined') {
        return post.categories.edges[0].node.name;
      }
    },
    getPostImage (post) {
      return getPostImage(post)
    },
    isPostNew (date) {
      const months = 1000 * 60 * 60 * 24 * 31 * 3;
      const threeMonthsAgo = Date.now() - months;

      return date > threeMonthsAgo;
    }
  }
}
</script>
